module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }